"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BestCourseLengthCalculator = void 0;
var tslib_1 = require("tslib");
var axios_1 = tslib_1.__importDefault(require("axios"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importStar(require("react"));
var ImageUniversal_1 = require("../green-section/containers/ImageUniversal/ImageUniversal");
var SocialShare_1 = require("../green-section/Video/VideoDetail/SocialShare");
var ScreenInput_1 = tslib_1.__importDefault(require("./ScreenInput"));
var ScreenResult_1 = tslib_1.__importDefault(require("./ScreenResult"));
require("./styles.less");
var util_1 = require("./util");
function BestCourseLengthCalculator(_a) {
    var endpoint = _a.endpoint, calculationEndpoint = _a.calculationEndpoint, token = _a.token, logo = _a.logo, authorMode = _a.authorMode;
    var CTA_CLICK_EVENT = 'best-course-length-calculator-cta-clicks';
    var _b = react_1.useState(''), gender = _b[0], setGender = _b[1];
    var _c = react_1.useState(0), screen = _c[0], setScreen = _c[1];
    var _d = react_1.useState(''), errorMessage = _d[0], setErrorMessage = _d[1];
    var _e = react_1.useState(null), course = _e[0], setCourse = _e[1];
    var _f = react_1.useState([]), courseList = _f[0], setCourseList = _f[1];
    var _g = react_1.useState(0), coursePar = _g[0], setCoursePar = _g[1];
    var _h = react_1.useState(new Map()), courseDetails = _h[0], setCourseDetails = _h[1];
    var _j = react_1.useState(0), bestFitCourseLength = _j[0], setBestFitCourseLength = _j[1];
    var _k = react_1.useState(''), parThree = _k[0], setParThree = _k[1];
    var _l = react_1.useState(''), parFour = _l[0], setParFour = _l[1];
    var _m = react_1.useState(''), parFive = _m[0], setParFive = _m[1];
    var _o = react_1.useState(''), sevenIronDistance = _o[0], setSevenIronDistance = _o[1];
    react_1.useEffect(function () {
        if (courseDetails && courseDetails.size > 0) {
            updatePars();
        }
    }, [courseDetails]);
    react_1.useEffect(function () {
        if (gender === util_1.GENDER_OPTIONS.MALE || gender === util_1.GENDER_OPTIONS.FEMALE) {
            updatePars();
        }
    }, [gender]);
    var setDtm = function (props) {
        window.digitalData = window.digitalData || {};
        window.digitalData = $.extend(true, window.digitalData, props);
    };
    var trackDtm = function (ev, props, onDtmTrack) {
        if (window._satellite) {
            setDtm(props);
            window._satellite.track(ev);
            if (typeof onDtmTrack === 'function') {
                setTimeout(function () {
                    onDtmTrack(event, props, window.digitalData);
                }, 1000);
            }
        }
    };
    var handleReturnClick = function () {
        setGender('');
        setErrorMessage('');
        setParThree(function (previousValue) { return ''; });
        setParFour(function (previousValue) { return ''; });
        setParFive(function (previousValue) { return ''; });
        setCoursePar(0);
        setBestFitCourseLength(0);
        setScreen(0);
        setSevenIronDistance('');
        setCourse(null);
        setCourseDetails(new Map());
        setCourseList([]);
    };
    var handleSubmitClick = function () {
        trackDtm(CTA_CLICK_EVENT, {});
        setErrorMessage('');
        runCalculation();
    };
    // tslint:disable-next-line:no-empty
    var onSocialShare = function (network) {
    };
    var validateData = function () {
        var check = { result: true, error: 'None' };
        var seven = Number(sevenIronDistance);
        if (!sevenIronDistance && (!parThree && !parFour && !parFive)) {
            check.result = false;
            // tslint:disable-next-line:max-line-length
            check.error = 'Please enter Total 7-Iron distance and select a course or enter the course\'s Par 3, Par 4 and Par 5 details.';
        }
        if (!sevenIronDistance) {
            check.result = false;
            check.error = 'Please enter Total 7-Iron Distance.';
        }
        if (!seven || !(80 <= seven && seven <= 180)) {
            check.result = false;
            check.error = 'Please enter a valid number in Total 7-Iron distance.';
        }
        if (!parThree && !parFour && !parFive) {
            check.result = false;
            check.error = 'Please select a course or enter the course\'s Par 3, Par 4 and Par 5 details.';
        }
        if ((Number(parThree) + Number(parFour) + Number(parFive)) !== 18) {
            check.result = false;
            check.error = 'Total number of holes must equal 18.';
        }
        return check;
    };
    var updatePars = function () {
        var params = courseDetails.get(gender);
        if (!!params) {
            setParThree(params.par3);
            setParFour(params.par4);
            setParFive(params.par5);
            setCoursePar(params.coursePar);
        }
    };
    var computeCoursePar = function () {
        return 3 * Number(parThree) + 4 * Number(parFour) + 5 * Number(parFive);
    };
    var processCalculation = function () {
        axios_1.default.get(calculationEndpoint, {
            params: {
                par3: parThree,
                par4: parFour,
                par5: parFive,
                ironDist: sevenIronDistance,
            },
        })
            .then(function (response) {
            setBestFitCourseLength(response.data.result || 0);
            setCoursePar(computeCoursePar());
            setScreen(1);
        })
            .catch(function (err) {
            console.log('HERE error in process calculation', err);
        });
    };
    var runCalculation = function () {
        var valid = validateData();
        if (valid.result) {
            processCalculation();
        }
        else {
            setErrorMessage(valid.error);
        }
    };
    return (react_1.default.createElement("section", { className: classnames_1.default('best-course-length-calculator', authorMode ? 'author-mode' : '') },
        react_1.default.createElement("div", { className: "content" },
            react_1.default.createElement("div", { className: "heading" },
                react_1.default.createElement("div", { className: "title-container" },
                    !!logo && react_1.default.createElement(ImageUniversal_1.ImageUniversal, { image: logo }),
                    react_1.default.createElement("div", { className: 'title-wrapper' },
                        react_1.default.createElement("h2", { className: "title" }, "Best Fit Course Length Calculator")))),
            react_1.default.createElement("div", { className: "main-container" },
                screen === 4 && (react_1.default.createElement("div", { className: "description" },
                    react_1.default.createElement("span", null, "Please enter your details to get your Target Score based on championship course setup."))),
                react_1.default.createElement("div", { className: "main" },
                    screen === 0 &&
                        react_1.default.createElement(ScreenInput_1.default, { course: course, setCourse: setCourse, courseList: courseList, setCourseList: setCourseList, parThree: parThree, parFour: parFour, parFive: parFive, setParThree: setParThree, setParFour: setParFour, setParFive: setParFive, setCoursePar: setCoursePar, sevenIronDistance: sevenIronDistance, setSevenIronDistance: setSevenIronDistance, token: token, endpoint: endpoint, setErrorMessage: setErrorMessage, gender: gender, setGender: setGender, setCourseDetails: setCourseDetails }),
                    screen === 1 &&
                        react_1.default.createElement(ScreenResult_1.default, { bestFitCourseLength: bestFitCourseLength, coursePar: coursePar, parThree: parThree, parFour: parFour, parFive: parFive, gender: gender }),
                    react_1.default.createElement("div", { className: 'error-container' }, screen === 0 &&
                        !!gender &&
                        !!sevenIronDistance &&
                        errorMessage &&
                        (react_1.default.createElement("div", { className: "error-message" }, errorMessage)))),
                react_1.default.createElement("div", { className: classnames_1.default('footer', screen === 1 ? 'result' : '') },
                    screen === 0 &&
                        !!gender &&
                        !!sevenIronDistance &&
                        (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("button", { className: "cta-reset", onClick: handleReturnClick }, "Reset"),
                            react_1.default.createElement("button", { className: "cta-submit", onClick: handleSubmitClick }, "Submit"))),
                    screen === 1 &&
                        react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("button", { className: "cta-reset", onClick: handleReturnClick }, "Start Over"))),
                screen === 1 &&
                    react_1.default.createElement(SocialShare_1.SocialShare, { height: "30px", width: "30px", shareText: 'Best Fit Tees Calculator', onSocialShare: onSocialShare })))));
}
exports.BestCourseLengthCalculator = BestCourseLengthCalculator;
